export default __webpack_public_path__ + "static/media/menuLeftPolygon.12d51d36.svg";